import { isNonMobileWeb, LabelRegular, YStack } from 'smoothie';

import { GENERAL_DISCLOSURES_TEXT } from '../../../banking/components/Disclosures';

export const NewMemberDisclosuresFooter = () => {
    return (
        <YStack paddingBottom={isNonMobileWeb ? 32 : 16}>
            <LabelRegular textAlign="left" color="$gray900">
                {GENERAL_DISCLOSURES_TEXT}
            </LabelRegular>
        </YStack>
    );
};
